/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-29 15:29:32
 *
 *******************************************************/
// @flow

export const MERGE_VALUES_TYPES = [
  {
    value: 'vendor',
    label: 'AdminHTML.MergeValues.Constant.mergeValuesTypes1_Label'
  },
  {
    value: 'product_type',
    label: 'AdminHTML.MergeValues.Constant.mergeValuesTypes2_Label'
  },
  { value: 'tag', label: 'AdminHTML.MergeValues.Constant.mergeValuesTypes3_Label' }
];
